import { fill, SHARED_COUNTRIES_TEXTS as T } from './texts'

// ALL countries as ISO 3166-1 alpha-2 codes — a standard, not a choice of ours. Lived in
// client/lookups.ts until 2026-10-23 and moved here when the server had to check a country
// against the SAME list the pickers offer (brand mask: „XX" must not get through, not even past
// the UI). One list for both sides; the German names come from Intl.DisplayNames in the client.
export const ISO_COUNTRY_CODES: readonly string[] = ('AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN '
    + 'BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC '
    + 'EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR '
    + 'HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT '
    + 'LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP '
    + 'NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL '
    + 'SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE '
    + 'VG VI VN VU WF WS YE YT ZA ZM ZW').split(' ')

// Whether `code` is one of the codes above. Expects it already trimmed and upper-cased.
export const isCountryCode = (code: string) => ISO_COUNTRY_CODES.includes(code)

// A country as a mask or an API sends it: trimmed and upper-cased, '' when empty. Anything else
// off the list is refused with a 400 — every place that stores a country typed in here checks
// it this way (operator, 2026-10-23: „alle Länder dürfen nur über die Liste ausgewählt werden").
// Values that only arrive from outside (shop, payment providers, WordPress) are not checked here.
export function checkedCountry(raw: unknown): string {
    const code = String(raw ?? '').trim().toUpperCase()
    if (code && !isCountryCode(code)) {
        throw Object.assign(new Error(fill(T.unknown, { code })), { statusCode: 400 })
    }
    return code
}
